import React from 'react';
import EditorLayoutGrid from '@wix/da-ds/pkg/Icons/24x24/EditorLayoutGrid';
import EditorLayoutTorpedo from '@wix/da-ds/pkg/Icons/24x24/EditorLayoutTorpedo';
import { useTranslation } from 'react-i18next';
import EditorIconButtonWithContextMenu from '../../../../components/menus/_partials/EditorIconButtonWithContextMenu';
const Layout = ({ editor })=>{
    const { t } = useTranslation('editor');
    let CurrentIcon = EditorLayoutGrid;
    if (editor.isActive('da-gallery', {
        layout: 'torpedo'
    })) {
        CurrentIcon = EditorLayoutTorpedo;
    }
    if (!editor.can().chain().focus().daGalleryChangeLayout('grid').run()) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(EditorIconButtonWithContextMenu, {
        featureId: "node:gallery:layout",
        "aria-label": t('ext.gallery.button.layout'),
        tooltipText: t('ext.gallery.button.layout'),
        icon: CurrentIcon,
        items: [
            {
                featureId: 'node:gallery:gridLayout',
                label: 'Grid',
                icon: /*#__PURE__*/ React.createElement(EditorLayoutGrid, null),
                selected: editor.isActive('da-gallery', {
                    layout: 'grid'
                }),
                onClick: ()=>{
                    editor.chain().focus().daGalleryChangeLayout('grid').run();
                }
            },
            {
                featureId: 'node:gallery:masonryLayout',
                label: 'Masonry',
                icon: /*#__PURE__*/ React.createElement(EditorLayoutTorpedo, null),
                selected: editor.isActive('da-gallery', {
                    layout: 'torpedo'
                }),
                onClick: ()=>{
                    editor.chain().focus().daGalleryChangeLayout('torpedo').run();
                }
            }
        ]
    });
};
Layout.displayName = 'Layout';
export default Layout;

//# sourceMappingURL=Layout.js.map